import PropTypes from 'prop-types'
import React from 'react'
import { TagBox } from '../../molecules/TagBox'
import { Button } from '../../atoms/Button'
import useUser, { urlFetch } from '../../../hooks/useUser'
import useMutation from '../../../hooks/useMutation'
import { urlToJson } from '../../../utils/helpers'
import { isPresentInGobPe } from '../../../configs/usersConfig'

const passwordChangeText = {
  true: { label: 'NO', tagType: 'warning' },
  false: { label: 'SI', tagType: 'success' }
}

const UserPasswordReset = ({ user }) => {
  const needsChange = !!user.required_password_change
  const status = passwordChangeText[needsChange]
  const { togglePasswordChange, invalidateUsers } = useUser()
  return (
    <div className="flex flex-col items-start gap-1">
      <TagBox className="text-xs" label={status.label} tagType={status.tagType} />
    </div>
  )
}

UserPasswordReset.propTypes = {
  user: PropTypes.object
}

export default UserPasswordReset
